import { Config } from 'config';

import { assign } from 'lodash';

// Avoid polluting the global space with the lodash variable
window._.noConflict();

import * as Util from 'gear';
import * as Cdl from 'cdl';

import * as Resources from '../resources';

let { Cx } = window;

// Assign properties from CoreJS Cx.Config, compatibility with Cx.Config.set(...)
if( Cx.Config ) {
  assign( Config, Cx.Config );
}

// Cx.Base, Cx.map$ ...
assign( Cx, Util );

// Cx.Document, Cx.Figure, Cx.Point ...
assign( Cx, Cdl );

// Cx.translate, Cx.bounds$, ...
assign( Cx, Cdl.Figures );

// Cx.GlobalCoreResourceManager, ...
assign( Cx, Resources );

// The global resource manager is used by global methods like Document.load$(id)
// Default to Core, applications can define their own resource managers
Config.GlobalResourceManager = Config.coreX ? new Cx.CoreXResourceManager({ app: Config.coreX })
                                            : new Cx.GlobalCoreResourceManager();



/** WEBPACK FOOTER **
 ** ./src/web/cdl.js
 **/